<template>
  <nav :aria-label="labels.SEN_GUIDA_BREADCRUMBS_ARIALABEL" class="breadcrumbs">
    <ul>
      <li>
        <router-link :to="{ query: {} }">{{
          labels.SEN_GUIDA_BREADCRUMBS_ROOT
        }}</router-link>
      </li>
      <template v-if="!$route.query.sorgente">
        <li v-for="(item, index, i) in $route.query" :key="item">
          <BreadcrumbsNavigationItem :level="i + 1" />
        </li>
      </template>
    </ul>
  </nav>
</template>
<script>
import BreadcrumbsNavigationItem from "./BreadcrumbsNavigationItem.vue";
import labels from "@/data/labels.json";

export default {
  components: {
    BreadcrumbsNavigationItem,
  },
  data() {
    return {
      labels,
    };
  },
};
</script>
<style></style>
